import { render, staticRenderFns } from "./resendAccessCodeComponent.vue?vue&type=template&id=1f6859b5"
import script from "./resendAccessCodeComponent.vue?vue&type=script&lang=js"
export * from "./resendAccessCodeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports